/* eslint-disable guard-for-in,no-plusplus,no-restricted-syntax,@typescript-eslint/no-shadow,no-underscore-dangle,@typescript-eslint/no-use-before-define */

import { EVENTS } from '../../../app/constants/events';

xplenty.directive('expressionEditorCode', [
  '$rootScope',

  function ($rootScope) {
    return {
      restrict: 'A',

      scope: null,

      link(scope, element, attrs) {
        if (attrs.expressionEditorCode === 'false') return;

        const $parent = element.parent();
        const $icon = angular.element('<i class="fa fa-edit expression-editor-icon"></i>');

        $parent.addClass('select-box');

        element.after($icon);

        const showEditor = function (event) {
          const extraVariables = {};
          const $target = angular.element(event.target);
          const $row = $target.closest('.variables-editor-row');
          const index = $row.index();

          let category = null;

          if ($row.parents('.packages-variables-workflow').length) {
            category = 'Workflow';
            const parentScope = scope.$parent.$parent.$parent;
            const variables = angular.copy(parentScope.variables);
            let _index = 0;
            for (const key in variables) {
              if (_index < index) {
                extraVariables[key] = variables[key];
              }
              _index++;
            }
          } else if ($row.parents('.user-variables').length) {
            category = 'User';
          } else if ($row.parents('.system-variables').length) {
            category = 'System';
          }

          $rootScope.$broadcast(EVENTS.EXPRESSION_EDITOR_SHOW, {
            code: element.val(),
            index,
            category,
            extraVariables,
          });

          const $openEvent = $rootScope.$on(EVENTS.EXPRESSION_EDITOR_SAVE, function (event, code) {
            element.val(code);
            element.triggerHandler('input');
            cancelEvents();
          });

          const $closeEvent = $rootScope.$on(EVENTS.EXPRESSION_EDITOR_CLOSE, function () {
            cancelEvents();
          });

          function cancelEvents() {
            $openEvent();
            $closeEvent();
          }
        };

        $icon.on('click', showEditor);

        element.on('keyup', function (e) {
          const code = e.keyCode || e.which;
          if (code === 13) {
            if (e.shiftKey) {
              showEditor(e);
            }
          }
        });
      },
    };
  },
]);
